import React from 'react';
import ComplexetyLevel from './ComplexetyLevel';
import ComplexetyLevelDataProvider from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { subtitlesMap } from '../../Common/maps/subtitleMap';

const ComplexetyLevelWrapper = ({ queryConfig, module }) => {
    return (
        <ComplexetyLevelDataProvider
            module={module}
            queryConfig={queryConfig}
            subtitlesMap={subtitlesMap}
        >
            <ComplexetyLevel />
        </ComplexetyLevelDataProvider>
    );
};

export default ComplexetyLevelWrapper;
